module.exports = __webpack_public_path__ + "img/icon-whatsapp.16752a7d.svg";